import { useMutation, useQuery } from "react-query";
import { HttpBaseRequest } from "../../../../../core/HttpRequest";
import { useErrorHandler } from "../../../../../hooks/useErrorHandler";
import { AxiosError } from "axios";
import useSuccessHandler from "../../../../../hooks/useSuccessHandler";
import { add, get, gets, update } from "./service";
import {
  Form_Create_PaymentMethod,
  Form_Update_PaymentMethod,
} from "../../../form/paymentMethod/Form";

export const useGetPaymentMethods = ({
  keyword,
  page,
  perPage,
}: HttpBaseRequest) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    queryKey: `paymentMethod-${keyword}-${page}-${perPage}`,
    queryFn: () => get({ keyword, page, perPage }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useGetPaymentMethod = ({
  payment_method_id,
}: {
  payment_method_id?: string;
}) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    enabled: payment_method_id !== undefined,
    queryKey: `paymentMethod-${payment_method_id}`,
    queryFn: () => gets({ payment_method_id }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useAddPaymentMethod = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationKey: `addPaymentMethod`,
    mutationFn: ({ payment_method_name }: Form_Create_PaymentMethod) =>
      add({
        payment_method_name,
      }),
    onSuccess: (e) => {
      showToast("Berhasil menambahkan metode pembayaran baru");
      redirect("/invoice/payment-method");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useUpdatePaymentMethod = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationKey: `updatePaymentMethod`,
    mutationFn: ({
      payment_method_id,
      payment_method_name,
    }: Form_Update_PaymentMethod) =>
      update({
        payment_method_id,
        payment_method_name,
      }),
    onSuccess: (e) => {
      showToast("Berhasil update metode pembayaran");
      redirect("/invoice/payment-method");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};
